import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './Subscription.css';

const Subscription = () => {
  return (
    <div className="elegant-app">
      <Header />
      <main className="elegant-main">
        <div className="elegant-create-container">
          <div className="elegant-create-header">
            <h1 className="elegant-create-title">订阅专区</h1>
            <p className="elegant-create-subtitle">解锁更多高级功能，享受尊贵体验</p>
          </div>
          
          <div className="subscription-benefits">
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-robot"></i>
              </div>
              <h3>AI 辅助创作</h3>
              <p>使用高级 AI 助手，帮助您创作更精彩的海龟汤</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-crown"></i>
              </div>
              <h3>尊贵权益</h3>
              <p>享受专属订阅界面主题和个性化定制选项</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-star"></i>
              </div>
              <h3>可优先被推荐</h3>
              <p>您的海龟汤作品将获得优先推荐展示</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="fas fa-plus-circle"></i>
              </div>
              <h3>可创作更多作品</h3>
              <p>解锁所有海龟汤高级内容，不受任何创作限制</p>
            </div>
          </div>
          
          <div className="subscription-plans">
            <h2>订阅套餐</h2>
            <div className="plans-container">
              <div className="plan-card">
                <div className="plan-header">
                  <h3>月度订阅</h3>
                  <div className="plan-price">¥8<span>/月</span></div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button className="plan-button" style={{ width: '120px' }}>立即订阅</button>
                </div>
              </div>
              
              <div className="plan-card">
                <div className="plan-header">
                  <h3>季度订阅</h3>
                  <div className="plan-price">¥20<span>/季</span></div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button className="plan-button" style={{ width: '120px' }}>立即订阅</button>
                </div>
              </div>
              
              <div className="plan-card featured">
                <div className="plan-header">
                  <h3>年度订阅</h3>
                  <div className="plan-price">¥72<span>/年</span></div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button className="plan-button" style={{ width: '120px' }}>立即订阅</button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="subscription-faq">
            <h2>常见问题</h2>
            <div className="faq-container">
              <div className="faq-item">
                <h3>如何订阅我们的服务？</h3>
                <p>您可以选择上方任一套餐，点击"立即订阅"后按照流程完成支付即可成为订阅用户。</p>
              </div>
              <div className="faq-item">
                <h3>订阅特权有哪些？</h3>
                <p>订阅用户可以享受无广告浏览、内容无限制、AI创作辅助、作品优先推荐等多项特权。</p>
              </div>
              <div className="faq-item">
                <h3>可以随时取消订阅吗？</h3>
                <p>月度和年度订阅可以在用户中心随时取消自动续费，已付费的有效期内仍可享受订阅特权。</p>
              </div>
              <div className="faq-item">
                <h3>支持哪些支付方式？</h3>
                <p>我们支持支付宝、微信支付、银联以及主流信用卡等多种支付方式。</p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Subscription; 